import _actions_set_current_setting from './_actions/set_current_setting.js'
import _actions_save from './_actions/save.js'
import _actions_init from './_actions/init.js'
import _actions_get from './_actions/get.js'
import _actions_delete from './_actions/delete.js'
import _getters_currentSetting from './_getters/currentSetting.js'
import _mutations_settings from './_mutations/settings.js'
import _mutations_resolves from './_mutations/resolves.js'
import _mutations_payment_systems from './_mutations/payment_systems.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_current_setting from './_mutations/current_setting.js'
import _mutations_change_settings from './_mutations/change_settings.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        change_settings: _mutations_change_settings,
        current_setting: _mutations_current_setting,
        loading: _mutations_loading,
        payment_systems: _mutations_payment_systems,
        resolves: _mutations_resolves,
        settings: _mutations_settings,
    },
    getters:{
        currentSetting: _getters_currentSetting,
    },
    actions:{
        delete: _actions_delete,
        get: _actions_get,
        init: _actions_init,
        save: _actions_save,
        set_current_setting: _actions_set_current_setting,
    },
}